var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeiculoDeApoio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.467,
    height: 18.494,
    viewBox: "0 0 41.467 18.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_908",
    "data-name": "Caminho 908",
    d: "M281.214,502.119a3.351,3.351,0,0,0-1.019-2.045,1.391,1.391,0,0,1-.495-1.479,4.256,4.256,0,0,0-.538-3.182c-.259-.423-.5-.856-.749-1.275.456-.181-.747-2.2-1.663-2.39a56.2,56.2,0,0,0-7.733-1.129c-1.883-.127-3.774-.148-5.661-.173a12.608,12.608,0,0,0-5.006.914,26.09,26.09,0,0,0-4.157,2.458,10.878,10.878,0,0,1-4.624,1.744,18.892,18.892,0,0,0-3.922.689,6.78,6.78,0,0,0-4.151,3.289,4.545,4.545,0,0,1-1.423,1.851.357.357,0,0,0-.1.278c.043.657.1,1.314.156,1.97a3.969,3.969,0,0,0,.512,2.08,1.639,1.639,0,0,0,1.59.7h0l.732-.006a3.442,3.442,0,0,0,3.387,2.5,3.5,3.5,0,0,0,3.355-2.568l22.858-.213a3.523,3.523,0,0,0,6.908-.064l.7-.006c.808.01.959-.1,1.131-.833A7.048,7.048,0,0,0,281.214,502.119Z",
    transform: "translate(-239.969 -490.443)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeiculoDeApoio);
export default __webpack_public_path__ + "static/media/veiculo-de-apoio.8ab143d87fc3d71ac389776c702b5777.svg";
export { ForwardRef as ReactComponent };